<template>
  <div id="container" class="flex_one">
    <div class="list_box full_layout">
      <div class="list_left_box">
        <ul class="my_card_hoddy">
          <li :class="(isWhat[1]=='recently')?'on':''">
            <router-link :to="{path:'/mycardhobby/recently'}">{{$t('base.recentlyViewed')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='bids')?'on':''">
            <router-link :to="{path:'/mycardhobby/bids'}">{{$t('base.bidsOffers')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='purchase')?'on':''" class="overseasWarehouse purchase">
            <router-link :to="{path:'/mycardhobby/purchase'}">{{$t('base.purchaseHistory')}}</router-link>
            <router-link :to="{path:'/terms/purchase'}" target="_blank" class="icon_process"></router-link>
          </li>
          <li :class="(isWhat[1]=='watch')?'on':''">
            <router-link :to="{path:'/mycardhobby/watch'}">{{$t('base.watchList')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='warehouse')?'on':''" class="overseasWarehouse">
            <router-link :to="{path:'/mycardhobby/warehouse'}">{{$t('base.overseaWarehouse')}}</router-link>
            <router-link :to="{path:'/terms/process'}" target="_blank" class="icon_process"></router-link>
          </li>
          <li :class="(isWhat[1]=='sellers')?'on':''">
            <router-link :to="{path:'/mycardhobby/sellers'}">{{$t('base.savedSellers')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='coupons')?'on':''">
            <router-link :to="{path:'/mycardhobby/coupons'}">{{$t('base.myCoupons')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='setting')?'on':''">
            <router-link :to="{path:'/mycardhobby/setting'}">{{$t('base.accountSettings')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='chp')?'on':''">
            <router-link :to="{path:'/mycardhobby/chp'}">{{$t('base.myCHP')}}</router-link>
          </li>
        </ul>
      </div>
      <div class="list_right_box" v-if="userInfo!=null">
        <router-view :userInfo='userInfo'></router-view>
      </div>
      <div class="list_right_box" v-else>
        <div class="user_no">{{$t('base.please')}} <router-link :to="{path:'/login'}" class="text_blue">{{$t('base.loginLower')}}</router-link> {{$t('alert.toViewItems')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
import { getInfo } from "@/api/public";

export default {
  name: 'tabslist',
  data () {
    return {
      userInfo:null,
      isWhat:this.$route.path.slice(1).split("/"),
    }
  },
  watch:{
    '$route':'getPath'
  },
  mounted() {
  },
  created(){
    bus.$emit('headerTitle',this.$t('base.myCardHobby'));
    this.userInfo = getInfo()
    if(this.userInfo==null){
      // Please sign in to view items.
    }
  },
  methods: {
    getPath(){
      let that=this
      this.isWhat=this.$route.path.slice(1).split("/")
      bus.$emit('headerTitle',that.$t('base.myCardHobby'));
    },
    
  } 
} 
</script>

<style scoped>
@import "../../../static/css/usertabslist.css";
</style>



// WEBPACK FOOTER //
// src/pages/user/tabslist.vue